import React from "react";
import { Col, Row } from "react-bootstrap";
import styled from "styled-components";
import Title from "../../../../utils/title/Title";
import { Colors } from "../../../../utils/colors/colors";
import { useExport } from "../../../../hooks/useExport";
import { IHeaderType } from "../../../../types/types";




const BeneficiaryHeader = () => {
  const {
    secondaryColor,
    primaryColor
  } = Colors();



  return (
    <Row>
      <Col>
        <BeneficiaryHeaderWrapper>
          <div
            style={{ marginBottom: "30px" }}
            data-aos="fade-up"
            data-aos-once="true"
          >
            <TitleWrapper>
              <Title
                textColor={primaryColor}
                text={"What Our"}
                style={{
                  margin: 0,
                  fontWeight: 700,
                  fontSize: "40px",
                }}
                type={IHeaderType.h3}
              />

              <Title
                textColor={secondaryColor}
                text={"Beneficiaries"}
                style={{
                  margin: 0,
                  fontWeight: 700,
                  fontSize: "40px",
                }}
                type={IHeaderType.h3}
              />
            </TitleWrapper>

            <Title
              textColor={primaryColor}
              text={"Are Saying"}
              style={{
                margin: 0,
                fontWeight: 700,
                fontSize: "40px",
              }}
              type={IHeaderType.h3}
            />
          </div>



        </BeneficiaryHeaderWrapper>
      </Col>
    </Row>
  );
};

export default BeneficiaryHeader;

const BeneficiaryHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;

  @media (min-width: 720px) {
    flex-direction: row;
  }
`;

const NavigationWrapper = styled.div`
  display: none;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 20px;
  position: relative;
  top: -33rem;

  @media (min-width: 768px) {
    display: flex;
  }
`;

const NavigationBtn = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 0px;
  gap: 20px;
  width: 50px;
  cursor: pointer;
`;

const TitleWrapper = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;


type IProps = {
  next: (currentSlide: number) => void;
  previous: (currentSlide: number) => void;
  goToSlide: (slideIndex: number) => void;
  carouselState: {
    currentSlide: number;
  };
};


export const BeneficiariesCarouselBtns = ({ next, previous, goToSlide, ...rest }: IProps) => {
  const { carouselState: { currentSlide } } = rest;

  const {
    backwardIconBtn,
    forwardIconBtn
  } = useExport();

  return (
    <>
      <NavigationWrapper>
        <NavigationBtn
          className={currentSlide === 0 ? 'disable' : ''}
          onClick={() => previous(currentSlide === 0 ? 0 : currentSlide - 1)}
          title="Previous"
        >
          <img
            src={backwardIconBtn}
            alt="Previous"
          />
        </NavigationBtn>

        <NavigationBtn
          onClick={() => next(currentSlide !== 0 ? currentSlide + 1 : currentSlide)}
          title="next"
        >
          <img
            src={forwardIconBtn}
            alt="next"
          />
        </NavigationBtn>
      </NavigationWrapper>
    </>
  )
}